import React from "react"
import styled from "styled-components"
import { Settings } from "../../../styles/theme"
import { Grid } from "../../atoms/grid"
import { Social } from "../../atoms/social"
import { StaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"

import SiteContext from "../../../context/SiteContext"

const Footerstyle = styled.div`
  position: relative;
  p,
  a,
  h6 {
    color: #fff;
  }
`

const Footerbottomstyle = styled.div`
  .blue {
    color: ${Settings.tertiaryColor};
    font-weight: 700;
  }
  .disclaimer {
    a {
      color: ${Settings.tertiaryColor};
      font-weight: 700;
    }
    p {
      font-weight: 700;
      color: ${Settings.tertiaryColor};
      text-align: right;
      @media screen and (max-width: ${Settings.sizeM}) {
        text-align: left;
      }
    }
  }
`

const Footertopstyle = styled.div`
  position: relative;
  background: ${Settings.primaryColor};
  padding: 1rem 0 2.5rem;
  overflow: hidden;
  .constraint {
    > div {
      align-items: flex-start;
    }
    position: relative;
    z-index: 1;
  }
  .logo {
    margin: 2rem;
    margin-top: 2.5rem;
    width: 120px;
    height: 51px;
    @media screen and (max-width: ${Settings.sizeL}) {
      margin-left: 0;
    }
  }
  .bg,
  img {
    margin: 0;
    width: 100%;
  }
  .bg {
    position: absolute !important;
    bottom: 0;
    left: 0;
    z-index: 0;
  }
  .social {
    > div {
      > div {
        > div {
          padding: 0 5px;
        }
      }
    }
  }
  h6 {
    margin-bottom: 1rem;
  }
  .footer-links {
    p {
      margin: 0;
      font-size: 0.9rem;
    }
  }
`

class FooterTop extends React.Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            experia: file(relativePath: { eq: "experia.png" }) {
              childImageSharp {
                fluid(maxWidth: 120) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            footer: file(relativePath: { eq: "footer.png" }) {
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        `}
        render={data => (
          <Footertopstyle>
            <div className="constraint footer-links">
              <Grid columns={3}>
                <div style={{ flex: "1 1 10%" }}>
                  <Img
                    fluid={data.experia.childImageSharp.fluid}
                    className="logo"
                  />
                </div>
                <div>
                  <div style={{ padding: "0 1rem" }}>
                    <h6>FOR GENERAL ENQUIRIES</h6>
                    <p>Tel: +65 6542 8660</p>
                    <p>Email: enquiries2022[at]singaporeairshow.com</p>
                  </div>
                </div>
                <div>
                  <h6>CONNECT WITH US</h6>
                  <div className="social">
                    <Social footer />
                  </div>
                </div>
              </Grid>
            </div>
          </Footertopstyle>
        )}
      />
    )
  }
}

FooterTop.contextType = SiteContext

const FooterBottom = () => (
  <Footerbottomstyle>
    <div className="constraint">
      <Grid columns={2}>
        <div>
          <p className="blue">© Singapore Airshow 2022. All Right Reserved.</p>
        </div>
        <div className="disclaimer">
          <p>
            <Link to="/disclaimer">Disclaimer</Link> |{" "}
            <Link to="/privacy-policy">Privacy Policy</Link>
          </p>
        </div>
      </Grid>
    </div>
  </Footerbottomstyle>
)

export const Footer = () => (
  <Footerstyle>
    <FooterTop />
    <FooterBottom />
  </Footerstyle>
)
